const TicketListType = {
	TICKETS: 'ticketList/tickets',
};

export default TicketListType;
